import { ContactRolesEnum } from '@/bundles/Contact/enums/contactRoles';

export const ContactRequirementRoles = [
  ContactRolesEnum.architect, ContactRolesEnum.civil_engineer, ContactRolesEnum.developer,
  ContactRolesEnum.listing_agent, ContactRolesEnum['listing_agent_-_sublease'], ContactRolesEnum.owner,
  ContactRolesEnum.property_manager, ContactRolesEnum.structural_engineer, ContactRolesEnum.true_owner,
  ContactRolesEnum.previous_owner, ContactRolesEnum.procuring_broker, ContactRolesEnum.ultimate_decision_maker, ContactRolesEnum.local_manager
];
